import * as RTabs from "@radix-ui/react-tabs";
import type { ReactNode } from "react";

export interface TabsProps {
  value: string;
  onValueChange: (value: string) => void;
  children: ReactNode;
  className?: string;
}

export function Tabs({
  value,
  onValueChange,
  children,
  className,
}: TabsProps): JSX.Element {
  return (
    <RTabs.Root
      className={className ?? "ds-tabs"}
      value={value}
      onValueChange={onValueChange}
    >
      {children}
    </RTabs.Root>
  );
}

export interface TabsListProps {
  children: ReactNode;
  ariaLabel: string;
  className?: string;
}

export function TabsList({
  children,
  ariaLabel,
  className,
}: TabsListProps): JSX.Element {
  return (
    <RTabs.List className={className ?? "ds-tabs__list"} aria-label={ariaLabel}>
      {children}
    </RTabs.List>
  );
}

export interface TabsTriggerProps {
  value: string;
  children: ReactNode;
  className?: string;
}

export function TabsTrigger({
  value,
  children,
  className,
}: TabsTriggerProps): JSX.Element {
  return (
    <RTabs.Trigger className={className ?? "ds-tabs__trigger"} value={value}>
      {children}
    </RTabs.Trigger>
  );
}

export interface TabsContentProps {
  value: string;
  children: ReactNode;
  className?: string;
}

export function TabsContent({
  value,
  children,
  className,
}: TabsContentProps): JSX.Element {
  return (
    <RTabs.Content className={className ?? "ds-tabs__content"} value={value}>
      {children}
    </RTabs.Content>
  );
}
